import React from "react";
import { Typography, Button, Tag } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Views } from "react-big-calendar";
import PatientsList from "./PatientsList";
import moment from "moment";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
const { Title } = Typography;

const Header = (props) => {
  const {
    calenderView,
    currentDate,
    onNextDate,
    onPreviousDate,
    onFilterPatientsChanged,
    ordersIds,
    events,
    patientsPallette,
    modal,
    comp,
    order_time_extractions,
    filteredOrders,
    activeEmployee,
  } = props;
  const intl = useIntl();

  const employeeMaxMonthlyHours = useSelector(
    (state) => state.organization.details.employee_max_monthly_hours
  );

  let date =
    calenderView === Views.DAY
      ? moment(currentDate).format("LL")
      : calenderView === Views.WEEK
      ? `${moment(currentDate).startOf("week").format("DD/MM/YYYY")} - ${moment(
          currentDate
        )
          .endOf("week")
          .format("DD/MM/YYYY")}`
      : moment(currentDate).format("MMMM YYYY");
  date =
    calenderView === Views.DAY
      ? `${date} (${moment(currentDate).format("dddd")})`
      : date;

  const disabledNext =
    calenderView === Views.WEEK &&
    !moment(moment(currentDate).add(1, "week")).isSame(
      moment(currentDate),
      "month"
    );

  const disabledPrevious =
    calenderView === Views.WEEK &&
    !moment(moment(currentDate).subtract(1, "week")).isSame(
      moment(currentDate),
      "month"
    );

  const view =
    calenderView === Views.DAY
      ? "day"
      : calenderView === Views.WEEK
      ? "week"
      : "month";

  const effectiveEvents = events.filter(
    (i) =>
      moment(i.date) > moment(currentDate).startOf(view) &&
      moment(i.date) < moment(currentDate).endOf(view)
  );

  // Filter for approved events and count unique days
  const approvedEvents = effectiveEvents.filter((event) => event.approved);
  const uniqueDays = new Set(
    approvedEvents.map((event) => moment(event.date).format("YYYY-MM-DD"))
  );
  const uniqueDaysCount = uniqueDays.size;

  const total =
    Math.round(
      (effectiveEvents.reduce((a, b) => +a + +b.duration_minutes, 0) / 60) * 100
    ) / 100;

  const availableHours =
    (activeEmployee && activeEmployee.max_monthly_hours) ||
    employeeMaxMonthlyHours ||
    null;
  const available = (availableHours - total).toFixed(2);
  const AvailableTag = () => (
    <Tag
      style={{ margin: 0 }}
      color={availableHours - total < 0 ? "error" : "default"}
    >
      {`${total} ${intl.formatMessage({
        id: "app.scheduling.totalSceduledHours",
      })} (${Math.abs(available)} ${intl.formatMessage({
        id:
          available < 0
            ? "app.scheduling.overFlowHours"
            : "app.scheduling.availableHours",
      })})`}
    </Tag>
  );
  const DatePicker = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      {calenderView === Views.MONTH && availableHours && total ? (
        <AvailableTag />
      ) : total ? (
        <Tag style={{ margin: 0 }}>{`${total} ${intl.formatMessage({
          id: "app.scheduling.totalSceduledHours",
        })} | ${uniqueDaysCount} ${intl.formatMessage({
          id: "app.scheduling.uniqueDays",
        })}`}</Tag>
      ) : null}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          width:
            calenderView === Views.MONTH
              ? "200px"
              : calenderView === Views.WEEK
              ? "360px"
              : "330px",
        }}
      >
        <Button
          type="text"
          shape="circle"
          icon={<RightOutlined />}
          onClick={onPreviousDate}
          disabled={disabledPrevious}
        />
        <Title level={4} style={{ margin: "0px", lineHeight: 1.5 }}>
          {date}
        </Title>
        <Button
          type="text"
          shape="circle"
          icon={<LeftOutlined />}
          onClick={onNextDate}
          disabled={disabledNext}
        />
      </div>
    </div>
  );
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <DatePicker />
      <PatientsList
        onFilterPatientsChanged={onFilterPatientsChanged}
        ordersIds={ordersIds}
        events={events.filter((i) => !(i.ghost === true))}
        patientsPallette={patientsPallette}
        modal={modal}
        order_time_extractions={order_time_extractions}
        filteredOrders={filteredOrders}
      />
      {comp}
    </div>
  );
};

export default Header;
